export default {
	namespaced: true,

	state: {
		list: []
	},

	mutations: {
		/**
		 * [setList description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setList(state, payload) {
			state.list=payload
		}
	},

	getters: {
		/**
		 * [list description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		list(state) {
			return state.list
		}
	}
}